import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  applications: [],
  recentApplications: [],
  application: {}
};

const slice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET APPLICATIONS LIST
    getApplicationsSuccess(state, action) {
      state.isLoading = false;
      state.applications = action.payload.applications;
    },

    // GET RECENT APPLICATIONS LIST
    getRecentApplicationsSuccess(state, action) {
      state.isLoading = false;
      state.recentApplications = action.payload.applications;
    },

    // GET APPLICATION
    getApplicationSuccess(state, action) {
      state.isLoading = false;
      state.application = action.payload;
    },

    // UPDATE APPLICATION
    updateApplicationSuccess(state, action) {
      state.isLoading = false;
      state.application = action.payload;
    },

    // CREATE APPLICATION
    createApplicationSuccess(state, action) {
      state.isLoading = false;
      state.application = action.payload;
    },

    // CANCEL APPLICATION
    createApplicationSuccess(state, action) {
      state.isLoading = false;
      state.application = action.payload;
    },

    // RESET APPLICATION
    resetApplication(state) {
      state.isLoading = false;
      state.application = {};
      console.log('reset application');
    },

  },
});

// Reducer
export default slice.reducer;

// Actions
export const { resetApplication } = slice.actions;

// ----------------------------------------------------------------------

export function createApplication(data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/creditline/application/create', data);
      if (response.data.error) {
        dispatch(slice.actions.hasError(response.data));
      } else {
        dispatch(slice.actions.createApplicationSuccess(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateApplication(data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/creditline/application/update', data);
      dispatch(slice.actions.updateApplicationSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function cancelApplication(applicationId, cancellationReason) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/creditline/application/cancel', {
        applicationId,
        cancellationReason
      });
      dispatch(slice.actions.cancelApplicationSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getApplicationById(applicationId) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/creditline/application/get?application_id='+applicationId);
      dispatch(slice.actions.getApplicationSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getApplicationByMobile(mobile) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/creditline/application/get?mobile='+mobile);
      dispatch(slice.actions.getApplicationSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getRecentApplications() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/creditline/applications/recent');
      dispatch(slice.actions.getRecentApplicationsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getApplications() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/creditline/applications/list');
      dispatch(slice.actions.getApplicationsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

